import React, { useState, useEffect } from 'react'
import './styles.css';
import { useHistory } from 'react-router';
import lodash from 'lodash';
import { useAppState } from '../../contexts/appState'
import useTranslation from '../../hooks/use-translation';
import { useIsMobile } from '../../hooks/breakpoints';
import { parseQueryString } from '../../utils/utils';
import useLoader from '../../hooks/use-loader';
import { isJhhIdVerified } from '../VaccinationCertificate/Utils/isJhhIdVerified';
import { _getErrorMessage } from '../VaccinationDetails/VaccinationDetailsWrapper/Utils/getErrorMessage';

const Profile = () => {
  const history = useHistory();
  const [{ user }, dispatch] = useAppState()
  const { t } = useTranslation();
  const isMobile = useIsMobile()
  const params = parseQueryString();
  const { showLoading, hideLoading } = useLoader();
  const urlParams = new URLSearchParams(window.location.search);
  const [pageLoadError, setPageLoadError] = useState();
  const name = atob(lodash.get(params, "t", ''))


  const _getJhhIdInfo = async () => {
    const auth_token = lodash.get(params, "auth_token", '');
    const source_id = lodash.get(params, "source_id", '').toLowerCase();
    const source_user_id = lodash.get(params, "source_user_id", '');
    const source_relation = lodash.get(params, "source_relation", '');
    const source_user_relation_id = lodash.get(params, "source_user_relation_id", '');
    if (!auth_token || !source_id || !source_user_id || !source_relation || !source_user_relation_id) {
      history.push('/');
    } else {
      const userDetailsObj = {
        auth_token,
        source_id,
        source_user_id,
        source_relation,
        source_user_relation_id
      };
      showLoading();
      let response;
      try {
        response = await isJhhIdVerified(userDetailsObj);
        dispatch({ type: 'UPDATE_USER', userData: { name, bookingHealthId: response.jhh_id } })
        hideLoading();
      } catch (error) {
        setPageLoadError(lodash.get(error, "message", t("RETRY_TEXT"), ''));
        hideLoading();
        return false
      }
      if (lodash.get(response, "status", '') !== "success") {
        setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")));
        return false;
      }
      if (lodash.get(response, "validated") == "no") {
        history.push(`/vaccinations-v2/verifyjhhid?${urlParams.toString()}`)
        return false;
      }
      return true;
    }
  }

  useEffect(() => {
    !user.bookingHealthId && _getJhhIdInfo();
  }, [user.bookingHealthId])


  if (pageLoadError) {
    return (<div className="vaccination-sc-page-load-error">{_getErrorMessage(pageLoadError)}</div>)
  }

  return (
    <div style={isMobile ? { paddingRight: '0.625rem', paddingLeft: '0.625rem' } : {}}>
      <div className={isMobile ? "profile-container-mobile" : "profile-container"}>
        <div className='profile-name'>{t('EOI_NAME')} : {user.name || '------'}</div>
        <div className='profile-jhhid'>{t('JHH_ID')} : {user.bookingHealthId || '------'}</div>
      </div >
    </div>
  )
}

export default Profile;
